module.exports = __webpack_public_path__ + "static/media/agendaEvent.932eecc9.png";